/* ============================================
   Customer Gallery — Scroll Animations
   IntersectionObserver, no external libraries
   ============================================ */

(function () {
  'use strict';

  function init() {
    const section = document.querySelector('.customer-gallery');
    if (!section) return;

    const speed = section.dataset.animationSpeed || 'normal';
    const speeds = {
      slow:   { duration: '0.8s', stagger: 100 },
      normal: { duration: '0.5s', stagger: 60 },
      fast:   { duration: '0.3s', stagger: 30 }
    };
    const cfg = speeds[speed] || speeds.normal;

    section.style.setProperty('--cg-anim-duration', cfg.duration);

    const cards = Array.from(section.querySelectorAll('.cg-card'));

    // Enforce lazy loading
    section.querySelectorAll('img').forEach(function (img) {
      if (!img.hasAttribute('loading')) img.setAttribute('loading', 'lazy');
      if (!img.hasAttribute('decoding')) img.setAttribute('decoding', 'async');
    });

    // Accessibility: aria-labels
    cards.forEach(function (card) {
      const customer = card.dataset.customer;
      if (customer && !card.getAttribute('aria-label')) {
        card.setAttribute('aria-label', 'View photo by ' + customer);
      }
      const img = card.querySelector('img');
      if (img && !img.getAttribute('alt')) {
        img.setAttribute('alt', customer ? 'Photo by ' + customer : 'Customer photo');
        img.setAttribute('role', 'img');
      }
    });

    // Hide cards initially
    cards.forEach(function (card) {
      card.classList.add('cg-hidden');
    });

    // IntersectionObserver
    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        const card = entry.target;
        const index = parseInt(card.dataset.index || 0, 10);
        const delay = Math.min(index * cfg.stagger, 600);

        card.style.willChange = 'transform, opacity';
        card.style.transitionDelay = delay + 'ms';
        card.classList.remove('cg-hidden');
        card.classList.add('cg-animate');

        // Clean up after animation
        setTimeout(function () {
          card.style.willChange = '';
          card.style.transitionDelay = '';
        }, parseFloat(cfg.duration) * 1000 + delay + 100);

        observer.unobserve(card);
      });
    }, { threshold: 0.1 });

    cards.forEach(function (card) { observer.observe(card); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
